module.exports = __webpack_public_path__ + "img/1571004516.4cf75cf8.jpg";